import List from '@utils/list'
import http from '@plugin/axios'
import { $t } from '@plugin/i18n'
const { Search, Table, Tabs, Operation } = List
// bidmanagementsup.biddingsignup
// 列表接口
function api(data: any) {
  const params = {
    ...data,
    condition: {
      ...data.condition,
      signStatus: data.condition.status,
      field: 'biddingNo',
      status: undefined
    }
  }
  return http({
    url: '/srmBiddingHead/getBiddingSignPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
}
function getDesc(value: string, prefix = 'bidmanagementsup.biddingsignup'): string {
  const i18n: any = $t(prefix)
  return i18n[value] || '-'
}
function gotoBiddingmonitoring(this: any, data: any) {
  this.$router.push({ name: 'Bidmanagementsup.Biddingsignup.Enroll', params: { id: data.id }})
}
const tabs = new Tabs()
  .url('/srmBiddingHead/getSignStatusCount', process.env.VUE_APP_PURCHASE_API)
  .name('statusName')
  .value('status')
  .count('statusCount')
  .prop('status')

const search = new Search('bidmanagementsup.biddingsignup')
  .placeholder('searchPlaceholder')
  .add('purOfficeNo').select('/purchaseUnit/getPurchaseUnitPage', { usingFlag: '1' })
  .add('biddingMode').op('modeOptions')

const table = new Table('bidmanagementsup.biddingsignup')
  .type('index')
  .add('biddingNo')
  .add('biddingName')
  .add('biddingMode').op('modeOptions')
  .add('signUpDeadline')
  .add('releaseDate')
  .add('startTime')
  .add('signStatus').format(({ row }) => getDesc(row.signStatus, 'bidmanagementsup.biddingsignup.signOptionsAll'))
  .add('refuseReason')

const operation = new Operation('bidmanagementsup.biddingsignup.operate')
  .width(150)
  .add('enter').disabled((row: any) => {
    const signUpDeadline = new Date(row.signUpDeadline).getTime()
    return !(new Date().getTime() <= signUpDeadline && row.signStatus === '1')
  })
  .handle(gotoBiddingmonitoring)

export default new List()
  .operation(operation)
  .api(api)
  .tabs(tabs)
  .search(search)
  .table(table)
  .end()
